<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>其他企业</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.provinceId" placeholder="请选择省" filterable @change="queryProvinceChange" style="width:130px">
					<el-option key="" label="请选择省" value=""></el-option>
					<el-option v-for="item in provinceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.cityId" placeholder="请选择城市" filterable @change="queryCityChange" style="width:130px">
					<el-option key="" label="请选择城市" value=""></el-option>
					<el-option v-for="item in queryCityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.areaId" placeholder="请选择区域" style="width:130px">
					<el-option key="" label="请选择区域" value=""></el-option>
					<el-option v-for="item in queryAreaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.name" placeholder="公司名称" class="handle-input mr10" style="width:220px"></el-input>
				<el-select v-model="query.status" placeholder="请选择状态" style="width:130px">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="建档" value = "0"></el-option>
					<el-option key="1" label="数据分析中" value = "1"></el-option>
					<el-option key="2" label="数据分析完成" value = "2"></el-option>
					<el-option key="3" label="已发信息" value = "3"></el-option>
					<el-option key="4" label="已成好友" value = "4"></el-option>
					<el-option key="5" label="已沟通" value = "5"></el-option>
					<el-option key="6" label="已合作" value = "6"></el-option>
					<el-option key="7" label="无效" value = "7"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.level" placeholder="请选择级别" style="width:160px">
					<el-option key="" label="请选择级别" value=""></el-option>
					<el-option v-for="item in levelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-lightning" @click="handleAnalysis" v-if="controll['analysis']">启动分析</el-button>&nbsp;
				<a href="https://img.zelixin.cn/template/资源信息模板.xlsx" style="font-size:12px;color:#66b1ff">资源信息模板</a>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				@cell-dblclick="handleShow"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="公司名称" width="250px"></el-table-column>
				<el-table-column prop="level" label="级别" width = "70px">
					<template slot-scope="scope">
						{{scope.row.level==0?"普通":"重点"}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width = "115px"></el-table-column>
				<el-table-column prop="resourcesType" label="资源类型" :formatter="customerTypeFormat" width = "100px"></el-table-column>
				<el-table-column prop="score" label="评分" width = "70px"></el-table-column>
				<el-table-column prop="mainBusiness" label="采集内容"></el-table-column>
				<el-table-column prop="website" label="网址" width="200">
					<template slot-scope="scope">
						<a :href= "(scope.row.website.indexOf('http')==-1?'http://':'') + scope.row.website" target="_blank" v-if="scope.row.website">{{scope.row.website}}</a>
                    </template>
				</el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="showCollectInfo(scope.$index, scope.row)"
							 v-if="controll['show-collect-info']"
                        >补充</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
				<el-button
                    type="primary"
					style="float:right"
                    icon="el-icon-cpu"
                    class="handle-del mr10"
                    @click="handleScore"
					v-if="controll['score']"
                >重新评分</el-button>
				<el-button
                    type="primary"
					style="float:right"
                    icon="el-icon-lx-edit"
                    class="handle-del mr10"
                    @click="handleUpdateStatus"
					v-if="controll['update-status']"
                >初始化</el-button>
				<el-upload
					style="float:right"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/potential-resources/import-excel"
					:on-success="uploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入资源信息</el-button>
				</el-upload>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
					:page-sizes="[10, 20, 50]"
                    @current-change="handlePageChange"
					@size-change="handleSizeChange"
                ></el-pagination>
            </div>
        </div>
		
		<v-PotentialResourcesEdit ref="potentialResourcesEdit"></v-PotentialResourcesEdit>
		<v-PotentialResourcesView ref="potentialResourcesView"></v-PotentialResourcesView>
		<v-PotentialResourcesCollectInfoAdd ref="potentialResourcesCollectInfoAdd"></v-PotentialResourcesCollectInfoAdd>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" width="70%">
			<el-form ref="preview" :model="preview" label-width="120px" :rules="previewRules">
				<el-form-item label="适用分析规则：" prop="currentRuleId">
					<el-select v-model="preview.currentRuleId" placeholder="请选择分析规则">
						<el-option key="" label="请选择分析规则" value=""></el-option>
						<el-option v-for="item in ruleKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="name" label="企业名称"></el-table-column>
				<el-table-column prop="companyType" label="企业类型"></el-table-column>
				<el-table-column prop="legalPerson" label="法定代表人" width="150px"></el-table-column>
				<el-table-column prop="registeredCapitalStr" label="注册资本" width="150px"></el-table-column>
				<el-table-column prop="establishDate" label="成立日期" width="150px"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getCurrentTime } from '../../../utils/common';
import { fetchPotentialResourcesData, savePotentialResources, deletePotentialResources, 
getPotentialResources, getEnumValueKV, savePotentialResourcesBatch, getAreaKv,  
getBaiduLocalCity, getPotentialResourcesSimple, analysisPotentialResources, 
updatePotentialResourcesStatus, getPotentialResourcesRuleKV,getPotentialResourcesPlatformKV, 
scorePotentialResources, getCompanyInfoPlatformKV} from '../../../api/index';
import vPotentialResourcesView from '../../common/PotentialResourcesView.vue';
import vPotentialResourcesEdit from '../../common/PotentialResourcesEdit.vue';
import vPotentialResourcesCollectInfoAdd from '../../common/PotentialResourcesCollectInfoAdd.vue';
import bus from '../../common/bus';

export default {
    name: 'potential-resources',
    data() {
		let checkRegisteredCapitalNotEmpty = (rule, value, callback) => {
			const numReg = /^[0-9.]*$/
			if (value) {
				if (numReg.test(value)) {
					callback();
				} else {
					callback(new Error('注册资本必须是数值型'));
				}
			} else {
				callback(new Error('注册资本不能为空'));
			}
		}
		let checkRealCapital = (rule, value, callback) => {
			const numReg = /^[0-9.]*$/
			if (value) {
				if (numReg.test(value)) {
					callback();
				} else {
					callback(new Error('注册资本必须是数值型'));
				}
			} else {
				callback();
			}
		}
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
			showVisible: false,
            pageTotal: 0,
            idx: -1,
            id: -1,
			cityEnumCode:1013,
			companyTypeEnumCode:1002,
			sourceEnumCode:1014,
			cityKV:{},
			companyTypeKV:{},
			sourceKV:{},
			title:"",
			previewRules: {
                currentRuleId: [{ required: true, message: '请选择适用的分析规则', trigger: 'blur' }]	
            },
			previewData:{},
			uuid:"",
			previewVisible:false,
			fileList:[],
			show:[],
			activeName:"baseTab",
			activeNameAdd:"companyTab",
			customerTypeCode:1002,
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
			provinceKV:[],
			cityKV:[],
			areaKV:[],
			queryCityKV:[],
			queryAreaKV:[],
			ruleKV:[],
			preview:{},
			platformKV:[],
			currentResource:{},
			companyInfoPlatformKV:[],
			controll:{},
			newVisible:false,
			levelKV:[{"key":0, "value":"普通"}, {"key":1, "value":"重点"}]
        };
    },
    created() {
		this.controll = getControll("potential-resources");
		this.getCompanyKV();
		this.getSourceKV();
        this.getData();
		this.getAreaKV(0, 0);
		this.getRuleKV();
		this.getPlatformKV();
		this.getCompanyInfoPlatform();
		bus.$on('potential-resources-change', msg => {
			if (this.idx == undefined) {
				this.getData();
			} else {
				this.$set(this.tableData, this.idx, msg);
			}
        });
    },
	components: {
        vPotentialResourcesView,
		vPotentialResourcesEdit,
		vPotentialResourcesCollectInfoAdd
    },
    methods: {
		handleAnalysis() {
			analysisPotentialResources().then(res=>{
				if (res.code == 0) {
					this.$message.success(`指令执行成功！`);
				} else {
					this.$message.error(`指令执行失败！` + res.message);
				}
			});
		},
		handleScore() {
			let ids = this.getIds();
			if (ids == null) {
				return;
			}
			this.$confirm('确定要对选中记录进行重新评分吗？', '提示', {
                type: 'warning'
            })
			.then(() => {
					scorePotentialResources(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('发送指令成功');
						} else {
							this.$message.error(`发送指令失败！` + res.message);
						}
					});
				})
			.catch(() => {});
		},
		getPlatformKV() {
			getPotentialResourcesPlatformKV().then(res => {
				if (res.code == 0) {
					this.platformKV = res.data;
				} else {
					this.$message.error(`获取辅助平台失败！` + res.message);
				}
			});
		},
		getCompanyInfoPlatform() {
			getCompanyInfoPlatformKV().then(res => {
				if (res.code == 0) {
					this.companyInfoPlatformKV = res.data;
				} else {
					this.$message.error(`获取企业信息平台失败！` + res.message);
				}
			});
		},
		getRuleKV() {
			getPotentialResourcesRuleKV().then(res => {
				if (res.code == 0) {
					this.ruleKV = res.data;
				} else {
					this.$message.error(`获取规则数据失败！` + res.message);
				}
			});
		},
		strEllipsis (value) {
			if (!value) return ''
			if (value.length > 90) {
				return value.slice(0, 90) + '...'
			}
			return value
		},
		//评分项转列表
		strToList(val) {
			let list = [];
			if (val == undefined) {
				return list;
			}
			let array = val.split('，');
			for(var i = 0; i < array.length; i++) {
				list.push(array[i]);
			}
			return list;
		},
		//评分项转列表
		scoreItemToList(val) {
			let list = [];
			if (val == undefined) {
				return list;
			}
			let array = val.split('，');
			for(var i = 0; i < array.length; i++) {
				list.push(array[i]);
			}
			return list;
		},
		provinceChange(value) {
			this.$set(this.form, 'cityId', '');
			this.areaKV = [];
			this.cityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 1);
		},
		cityChange(value) {
			this.areaKV = [];
			this.$set(this.form, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 2);
		},
		queryProvinceChange(value) {
			this.$set(this.query, 'cityId', '');
			this.queryAreaKV = [];
			this.queryCityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 3);
		},
		queryCityChange(value) {
			this.queryAreaKV = [];
			this.$set(this.query, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 4);
		},
		//获取省市区
		getAreaKV(parentId, type) {
			getAreaKv(parentId).then(res => {
				if (res.code == 0 ) {
					if (type == 0) {
						this.provinceKV = res.data;
					} else if (type == 1){
						this.cityKV = res.data;
					} else if (type == 2){
						this.areaKV = res.data;
					} else if (type == 3){
						this.queryCityKV = res.data;
					} else if (type == 4){
						this.queryAreaKV = res.data;
					}
				} else {
					this.$message.error("获取区域信息失败！" + res.message);
				}
			});
		},
		//客户类型格式化
		customerTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.customerTypeKV.length; i++) {
				if (this.customerTypeKV[i].key === cellValue){
					return this.customerTypeKV[i].value;
				}
			}
			return " - ";
		},
		cityIdFormat(row, column, cellValue) {
			for (var i = 0; i < this.cityKV.length; i++) {
				if (this.cityKV[i].key === cellValue){
					return this.cityKV[i].value;
				}
			}
			return cellValue;
		},
		typeFormat(row, column, cellValue) {
			for (var i = 0; i < this.companyTypeKV.length; i++) {
				if (this.companyTypeKV[i].key === cellValue){
					return this.companyTypeKV[i].value;
				}
			}
			return cellValue;
		},
		statusFormat(row, column, cellValue) {
			let statusKV = {"0":"建档", "1" :"数据分析中", "2":"数据分析完成","3" :"已发信息", "4":"已成好友", "5":"已沟通/拜访", "6":"已合作", "7":"无效"};
			if (typeof(cellValue) != undefined) {
				return statusKV[cellValue];
			}
			return cellValue;
		},
		getCompanyKV() {
			getEnumValueKV(this.companyTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.companyTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		getSourceKV() {
			getEnumValueKV(this.sourceEnumCode).then(res => {
				if (res.code == 0 ) {
					this.sourceKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取数据
        getData() {
            fetchPotentialResourcesData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResources([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		//显示采集信息
		showCollectInfo(index, row) {
			this.$nextTick(()=>{
				this.$refs.potentialResourcesCollectInfoAdd.setDatasource(row, this.platformKV);
			});
		},
		//删除选中记录
        delAllSelection() {
            let ids = this.getIds();
			if (ids == null) {
				return;
			}
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResources(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		handleUpdateStatus() {
			let ids = this.getIds();
			if (ids == null) {
				return;
			}
			let statusForm = {};
			statusForm["ids"] = ids;
			statusForm["status"] = 0;
			this.$confirm('确定要初始化选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					updatePotentialResourcesStatus(statusForm).then(res => {
						if (res.code == 0) {
							this.$message.success('初始化成功');
							this.getData();
						} else {
							this.$message.error(`初始化失败！` + res.message);
						}
					});
					})
				.catch(() => {});
		},
		getIds() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要初始化的记录！`);
				return null;
			}
			let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		},
		//添加操作
		handleAdd() {
			this.idx = undefined;
			this.$nextTick(()=>{
				this.$refs.potentialResourcesEdit.setDatasource(undefined, "添加新纪录", this.provinceKV, 
				this.ruleKV, this.companyInfoPlatformKV, this.sourceKV);
			});
		},
        // 编辑操作
        handleEdit(index, row) {
            if (this.controll['edit'] == undefined) {
				return;
			}
            this.idx = index;			
			getPotentialResources(row.id).then(res => {
				if (res.code == 0) {
					this.$nextTick(()=>{
						this.$refs.potentialResourcesEdit.setDatasource(res.data, "编辑", this.provinceKV, 
						this.ruleKV, undefined, this.sourceKV);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		// 显示操作
        handleShow(val) {
			if (this.controll['show'] == undefined) {
				return;
			}
			this.activeName = "baseTab";
			getPotentialResources(val.id).then(res => {
				if (res.code == 0) {
					this.$nextTick(()=>{
						this.$refs.potentialResourcesView.setDatasource(res.data, this.platformKV, false);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
            this.showVisible = true;
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleSizeChange(val) {
			this.$set(this.query, 'pageSize', val);
            this.getData();
		},
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.preview = {};
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		// 保存
        save() {
			this.$refs.preview.validate(valid => {
				if (valid) {
					let param = {};
					param["key"] = this.preview.currentRuleId;
					param["value"] = this.uuid;
					savePotentialResourcesBatch(param).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.previewVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					});
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        }
    }
};
</script>

<style scoped>

.bm-view {
    width: 100%;
    height: 85vh;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:85vh;
	width:10px;
	float:right;
	text-align:center;
	line-height:85vh;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}
</style>
